import { render, staticRenderFns } from "./StudentSetting.vue?vue&type=template&id=28043bd7&scoped=true&"
import script from "./StudentSetting.vue?vue&type=script&lang=js&"
export * from "./StudentSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28043bd7",
  null
  
)

export default component.exports